import React, { useEffect, useState } from 'react';
import '../assets/styles/Franchise.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft,faMagnifyingGlass ,faXmark  } from '@fortawesome/free-solid-svg-icons';
import pdfimg from '../assets/Francias/franciaspdf.svg';
import FranchiseAssign from './Assign/FranchiseAssign';
import { toast } from 'react-toastify';
import config from '../config.js';
import axios from 'axios';
import { ToastContainer } from 'react-bootstrap';

const Franchise = ({ pageName }) => {
    const [isFranchise, setIsFranchise] = useState(false);
    const [isFranchiseAssign, setIsFranchiseAssign] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [clientData, setClientData] = useState([]);
    const [filteredClientData, setFilteredClientData] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);
    const [isApproved, setIsApproved] = useState(1); 
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(24);  

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchValue(value);
        setFilteredClientData(
            clientData.filter((client) =>
                client.name.toLowerCase().includes(value.toLowerCase()) ||
                client.city.toLowerCase().includes(value.toLowerCase())
            )
        );
    };
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleCloseFranchise = () => setIsFranchise(false);
    const closeFranchiseAssign = () => {
        setIsFranchiseAssign(false);
        handleCloseFranchise();
        fetchClientData(); // 
    };

    const fetchClientData = async () => {
        try {
            const response = await fetch(`${config.apiBaseUrl}/admin/getfranchise`);
            if (!response.ok) {
                throw new Error('Failed to fetch client data');
            }
            const responseData = await response.json();
            setClientData(responseData.data);
            setFilteredClientData(responseData.data);
        } catch (err) {
            toast.error("Failed to fetch data ,network error");
        }
    };

    const fetchnotapprovereq = async () => {
        try {
            const response = await fetch(`${config.apiBaseUrl}/admin/notapprovereg`);
            if (!response.ok) {
                throw new Error('Failed to fetch unapproved client data');
            }
            const responseData = await response.json();
            setClientData(responseData.data);
            setFilteredClientData(responseData.data);
        } catch (err) {
            toast.error(err.message);
        }
    };

    const handleOpenPopup = async (id) => {
        try {
            const response = await fetch(`${config.apiBaseUrl}/admin/getfranchById/${id}`);
            if (!response.ok) throw new Error('Failed to fetch client details');

            const clientDetails = await response.json();
            setSelectedClient(clientDetails.data);
            setIsFranchise(true);
        } catch (err) {
            toast.error(err.message);
        }
    };
    const handleApproveFranchise = async (id) => {
        try {
            await axios.put(
                `${config.apiBaseUrl}/admin/approve-franchise`,
                { id, is_approved: true }
            );
            toast.success(`Franchise approved successfully`);
            setTimeout(() => {
                setIsFranchiseAssign(true);
            }, 2000);
        } catch (err) {
            const errorMessage = err.response?.data?.message || err.message || 'Failed to approve franchise';
            toast.error(errorMessage);
        }
    };




    const handleRadioChange = (event) => {
        const value = parseInt(event.target.value, 10);
        setIsApproved(value);
    };

    useEffect(() => {
        if (isApproved === 1) {
            fetchClientData();
        } else {
            fetchnotapprovereq();
        }
    }, [isApproved]);

    return isFranchiseAssign ? (
        <FranchiseAssign
            closePopup={closeFranchiseAssign}
            franchisedata={selectedClient}
            pageName={pageName}
        />
    ) : (
        <div className="camera-cm">
            <ToastContainer />
            <div className="row">
                <div className="col-5 col-md-6 col-lg-5">
                    <div className="search-bar">
                        <FontAwesomeIcon className="search-icon" icon={faMagnifyingGlass} />
                        <input
                            type="search"
                            placeholder="Search"
                            aria-label="Search"
                            className="search-bar-input"
                            value={searchValue}
                            onChange={handleSearchChange}
                        />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-7 d-flex justify-content-end mt-2">
                    <div className="form-check form-check-inline  ">
                        <input
                            className="form-check-input "
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio1"
                            value="1"
                            checked={isApproved === 1}
                            onChange={handleRadioChange}
                        />
                        <label className="form-check-label" htmlFor="inlineRadio1">Approved</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio2"
                            value="0"
                            checked={isApproved === 0}
                            onChange={handleRadioChange}
                        />
                        <label className="form-check-label" htmlFor="inlineRadio2">UnApproved</label>
                    </div>
                </div>
            </div>
            <div className="overall-containerf mt-2">
                <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead className="table-th">
                            <tr>
                                <th>S.no</th>
                                <th>Name</th>
                                <th>Total License</th>
                                <th>Available License</th>
                                <th>Location</th>
                                <th>Phone</th>
                                <th>Join date</th>
                                <th>Details</th>
                            </tr>
                        </thead>
                        <tbody className="tbody-responsive">
                            {filteredClientData.length > 0 ? (
                                filteredClientData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.name}</td>
                                        <td>{item.total_licenses}</td>
                                        <td>{item.available_license}</td>
                                        <td>{item.city}</td>
                                        <td>{item.phone_number}</td>
                                        <td>{new Date(item.created_at).toLocaleDateString()}</td>
                                        <td>
                                            <span
                                                className="clientviewpopup"
                                                onClick={() => handleOpenPopup(item.id)}
                                            >
                                                View
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" class="no-data">No data available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
              
            </div>

            <div className="pagination mt-2 d-flex justify-content-end">
                    <button className='leftcherve' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}><FontAwesomeIcon icon={faChevronLeft} /></button>
                    {Array.from({ length: Math.ceil(clientData.length / itemsPerPage) }, (_, index) => (
                        <button key={index} onClick={() => paginate(index + 1)} className={`paginationcnt ${currentPage === index + 1 ? 'active' : ''}`}>
                            {index + 1}
                        </button>
                    ))}
                    <button className='rightcherve' onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(clientData.length / itemsPerPage)}>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                </div>
            {isFranchise && selectedClient && (
                <div className="Franchise-overlay">
                    <ToastContainer />
                    <div className="Franchise-content">
                        <p onClick={handleCloseFranchise} className="text-end mb-0 mt-2">
                            <FontAwesomeIcon className="Franchise-close" icon={faXmark} />
                        </p>
                        <div className="modal-body">
                            <div className="popup-row">
                                <strong>Type</strong> <span>: Franchise</span>
                            </div>
                            <div className="popup-row">
                                <strong>Name</strong> <span>: {selectedClient.name}</span>
                            </div>
                            <div className="popup-row">
                                <strong>Phone no</strong> <span>: {selectedClient.phone_number}</span>
                            </div>
                            <div className="popup-row">
                                <strong>Email</strong> <span>: {selectedClient.email}</span>
                            </div>
                            <div className="popup-row">
                                <strong>Location</strong> <span>: {selectedClient.city}</span>
                            </div>
                            <div className="popup-row">
                                <strong>Post code</strong> <span>: {selectedClient.pincode}</span>
                            </div>
                            <div className="popup-row">
                                <strong>Company name</strong> <span>: {selectedClient.company_name}</span>
                            </div>
                            <div className="popup-row">
                                <strong>Business type</strong> <span>: {selectedClient.business_type}</span>
                            </div>
                            <div className="popup-row">
                                <strong>Industry</strong> <span>: {selectedClient.industry}</span>
                            </div>
                            <div className="popup-row">
                                <strong>Join Date</strong> <span>:{new Date(selectedClient.created_at).toLocaleDateString("en-US")}</span>
                            </div>
                            <div className="popup-row">
                                <strong>Total license</strong> <span>: {selectedClient.total_licenses_count}</span>
                            </div>
                            <div className="popup-row">
                                <strong>Available</strong> <span>: {selectedClient.available_license}</span>
                            </div>
                            <div className="popup-row">
                                <strong>purchase date</strong>
                                <span>: {selectedClient.last_purchased_date ? new Date(selectedClient.last_purchased_date).toLocaleDateString("en-US") : null}
                                </span>
                            </div>
                            <div className="popup-row">
                                <strong>Documents</strong>{' '}
                                <span className="document-icon">
                                    : <img src={pdfimg} alt="pdf" />
                                </span>
                            </div>
                            <div className="d-flex justify-content-end align-item-center mt-2 gap-2">
                                {isApproved === 0 ? (
                                    <>
                                        <button type="button" className="Franchise-denybtn" onClick={handleCloseFranchise} >
                                            Denied
                                        </button>
                                        <button type="button" className="Franchise-approvebtn" onClick={() => handleApproveFranchise(selectedClient.id)}>
                                            Approve
                                        </button>
                                    </>
                                ) : (
                                    <button type="button" className="Franchise-savebtn" onClick={() => setIsFranchiseAssign(true)}> Upgrade
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default Franchise;
